import(/* webpackMode: "eager" */ "/app/src/app/assistant/[assistantId]/page.tsx");
